export enum AppEnvironment {
  LOCAL = 'Local',
  CANARY = 'Canary',
  QA = 'QA',
  PROD = 'Production',
}

export enum AppEnvironmentLabel {
  LOCAL = 'LOCAL',
  CANARY = 'CANARY',
  QA = 'QA',
  PROD = '',
}
